import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { fetchFileList } from "@/core/app/slices/clinical/clinicalThunkApi"
import { resetOrder, setOrderSource } from "@/core/app/slices/order/orderSlice"
import { RootState } from "@/core/app/store"
import {
  attachmentModule,
  caseManagement,
  gdsPlusSetup,
  initialfinal,
  preview,
  relabelModule,
  stageControl,
  toothMovement,
  viewControlInTreatment,
  wasmModule,
} from "@/gluelayer"
import { resegmentationModule } from "@/gluelayer/core/modules/resegmentation/resegmentationModule"
import { useMyNavigation } from "@/hooks/useMyNavigation"
import { CASE_STATUS } from "@/modules/Patient/config/status.config"
import {
  setOpenCollisionCheck,
  setOpenOrderSplit,
  setOpenStlPrint,
  setSelectTxButton,
  setSelectTxDataSave,
  setTopLeftViewType,
  setZoomBarValue,
} from "@/UDTreat/udTreatSlice"
import Person from "@mui/icons-material/Person"
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Switch,
  ToggleButton,
  Tooltip,
  Typography,
} from "@mui/material"
import { useTheme } from "@mui/material/styles"
import {
  forwardRef,
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react"
import { useLocation, useParams, useSearchParams } from "react-router-dom"
import { orderButtonPopUpTmp } from "../bottom/Toggle/column"
import {
  setCurArch,
  setCurCaseMode,
  setCurLeftPage,
  setCurRightPage,
  setOpenBiteCheck,
  setOpenGrid,
  setOpenInitialFinal,
  setOpenLiteMode,
  setOpenOrientation,
  setopenSuperimpose,
  setSmartRxShow,
  setStageShowType,
  setSwitchViewEdit,
  setWorkflowMode,
} from "../udTreatSlice"

import { StatusIcon } from "./TopToolBarIcon"
import { ZoomBar } from "./ZoomBar"

import { UButton } from "@/components/index"
import { FILEZIPS } from "@/core/app/slices/clinical/clinicalSlice"
import DialogBox from "@/modules/Clinical/components/DialogBox/dialogBox"
import { getResultByPhotoJson } from "@/modules/Records/column"
import { Trans, useTranslation } from "react-i18next"
import { checkIsThereASpecifiedPhoto } from "../left/utils"
import { setUassistRxShow } from "../udTreatSlice"
import { PatientNameID } from "./PatientNameID"

import NewBackIcon from "../assets/toptoolbar_1_0/back.svg"
import NewLightmodeIcon from "../assets/toptoolbar_1_0/colored.svg"
import NewFrontIcon from "../assets/toptoolbar_1_0/front.svg"
import NewGridIcon from "../assets/toptoolbar_1_0/grid.svg"
import NewIPRIcon from "../assets/toptoolbar_1_0/ic_ipr.svg"
import NewOccIcon from "../assets/toptoolbar_1_0/ic_occlusogram.svg"
import NewSuperimpositionIcon from "../assets/toptoolbar_1_0/ic_superimposition.svg"
import NewInitialFinalIcon from "../assets/toptoolbar_1_0/initialfinal.svg"
import NewLeftIcon from "../assets/toptoolbar_1_0/left.svg"
import NewLowerIcon from "../assets/toptoolbar_1_0/lower.svg"
import NewRightIcon from "../assets/toptoolbar_1_0/right.svg"
import NewSplitIcon from "../assets/toptoolbar_1_0/split.svg"
import NewUpperIcon from "../assets/toptoolbar_1_0/upper.svg"

import StartRefinementPrompt from "@/components/StartRefinementPrompt/StartRefinementPrompt"
import { safeCloseWindow } from "@/core/app/CloseTabContext"
import { setData } from "@/core/app/slices/case/caseSlice"
import { openRefinement } from "@/core/app/slices/clinical/refinement/refinementThunkApi"
import {
  resetPrescriptionSchema,
  resetRxRefinementFormAdd,
  resetRxRefinementFormEdit,
  resetSchema,
} from "@/core/app/slices/uassist/formSlice"
import { UASSIST_STATUS } from "@/core/constants/UassistStatus"
import { dateFormat } from "@/core/utils/formatters"
import usePermissions from "@/hooks/userPermission"
import { hasFileHistoryChanged } from "@/modules/Patient/PatientList/util/commonUtil"
import { ETopLeftViewType } from "@/shared/types"
import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import classNames from "classnames"
import { ReactSVG } from "react-svg"
import SCCallbackManager, {
  userSelectTxChangeSave,
} from "../bottom/StageBar/stageCommon"
import { CaseUpdatedModal } from "../components/caseUpdatedModal"
import { usePageWidth } from "./GetViewWidth"
import MenuButtons from "./MenuButtons"
let callbackAfterIPRcheck = null

export const TopToolBar = forwardRef(
  (
    {
      setLockType,
      setOpenLockPopup,
      setisClickOrder,
      setispopupAfterOrder,
      switchEditCallBack,
      isEdit,
      ispopup,
      requestLock,
      onclickCloseBtn,
      isShowAssign,
    }: any,
    ref,
  ) => {
    // window innerWidth
    const windowWidth = usePageWidth()

    const { t } = useTranslation("common")
    const theme = useTheme()
    const navigate = useMyNavigation()
    const dispatch = useAppDispatch()
    const { caseId, patientId } = useParams()
    const [searchParams, setSearchParams] = useSearchParams()
    const from = searchParams.get("from")
    const {
      hasUploadSTLs,
      workflowMode,
      curCaseMode,
      smartRxShow,
      curArch,
      ucloud1_1,
      isCasePreview,
      isNewCaseHasUpload,
      switchViewEdit,
      planList,
      stageDataLen,
      isCreateNewRefinement,
      openHistorySplitView,
      widthAll,
      curRightPage,
      currentTreatmentPlan,
      openGrid,
      openSuperimpose,
      isOpenModelCheck,
      openRelabel,
      showJsPreview,
      singleArchBool,
      disabledUpper,
      disabledLower,
      ZoomBarValue,
      openOrientation,
      openOrderSplit,
    } = useAppSelector((state: RootState) => state.udTreatService)

    const {
      clinicalSettings: { NumberSystem },
    } = useAppSelector((state: RootState) => state.userService)
    const { caseDetail } = useAppSelector(
      (state: RootState) => state.caseService,
    )

    const { hasAny } = usePermissions()

    const {
      caseDisposition,
      upperType,
      lowerType,
      udesign_category,
      uassist_progress,
      is_printable,
      is_orderable,
    } = caseDetail
    const [curStatusString, setCurStatusString] = useState("")
    // tools button status (selected or not)

    const {
      openCollisionCheck,
      openBiteCheck,
      uassistRxShow,
      openStagingIPR,
      disabledBiteCheck,
      openInitialFinal,
      startAutoModelCheck,
      openLiteMode,
      isDoingPresetup,
    } = useAppSelector((state: RootState) => state.udTreatService)

    // const [openSuperimpose, setOpenSuperimpos] = useState<boolean>(false)
    // const [openGrid, setOpenGrid] = useState<boolean>(false)
    // const [openLiteMode, setOpenLiteMode] = useState<boolean>(false)
    const [openUassist, setOpenUassist] = useState<boolean>(false)
    const [isDeletePlan, setisDeletePlan] = useState<boolean>(false)
    const [showNoUassistPopup, setShowNoUassistPopup] = useState<boolean>(false)
    const [showNoUassistRetainerPopup, setShowNoUassistRetainerPopup] =
      useState<boolean>(false)
    const [openRefDialog, setOpenRefDialog] = useState<boolean>(false)
    const [showCaseUpdatedModal, setShowcaseUpdatedModal] = useState(false)
    const [sameLabelDlg, setSameLabelDlg] = useState(false)

    // check ipr before go to order
    const [checkIPRobj, setCheckIPRobj] = useState<{
      show: boolean
      showDetail: boolean
      detail: string
    }>({ show: false, showDetail: false, detail: "" })

    const location = useLocation()
    const { fileHistory } = useAppSelector(
      (state: RootState) => state.clinicalService,
    )

    const {
      patientData: { firstName = "", lastName = "" },
    } = useAppSelector((state: RootState) => {
      return state.patientService
    })

    const isShowRefinementSplitScreenOnLoad = useRef<boolean>(false)

    const { isShowProgress, isLoading, isWasmLoading } = useAppSelector(
      (state: RootState) => state.clinicalService,
    )

    const { user } = useAppSelector((state: RootState) => state.userService)

    const newCaseUDPlanStatus = [
      CASE_STATUS.DEFAULT,
      CASE_STATUS.COMPLETE_PATIENT_RECORDS,
      CASE_STATUS.PRESETUP_IN_PROGRESS,
      CASE_STATUS.FILL_OUT_RX_FORM,
      CASE_STATUS.SUBMIT_TO_UASSIST,
      CASE_STATUS.SUBMITTED_TO_UASSIST_REFINEMENT,
      CASE_STATUS.ATTENTION_NEEDED,
      CASE_STATUS.ATTENTION_NEEDED_REFINEMENT,
    ]
    const uDModiStatus = [
      CASE_STATUS.REVIEW_PLAN,
      CASE_STATUS.REVIEW_MODIFICATION,
    ]
    const uDViewStatus = [
      CASE_STATUS.SUBMITTED_TO_UASSIST,
      CASE_STATUS.MODIFICATION_REQUESTED,
      CASE_STATUS.PLANNING_IN_PROGRESS,
      CASE_STATUS.ORDER_SUBMITTED,
      CASE_STATUS.IN_PRODUCTION,
      CASE_STATUS.SHIPPED,
      CASE_STATUS.TREATMENT_IN_PROGRESS,
      CASE_STATUS.DELIVERED,
      CASE_STATUS.ARCHIVED,
      CASE_STATUS.CANCELLED,
    ]

    const handleKeyUp = useCallback(
      (event: KeyboardEvent) => {
        if (
          document.activeElement?.tagName === "INPUT" ||
          document.activeElement?.tagName === "TEXTAREA"
        ) {
          return
        }
        if (!wasmModule.isFinishedOpencase && !preview.isInitPreview()) return
        switch (event.key) {
          case "l":
          case "L":
            // Show and hide upper arch
            onClickUpperLower(false)
            return
          case "u":
          case "U":
            // Show and hide lower arch
            onClickUpperLower(true)
            return
        }

        if (
          isOpenModelCheck ||
          openOrderSplit ||
          !wasmModule.isFinishedOpencase
        )
          return
        switch (event.key) {
          case "1":
            // Left Lateral view (Patient Left)
            wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
            handleViewClick("left")
            break
          case "2":
            // Front view
            wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
            handleViewClick("front")
            break
          case "3":
            // Right Lateral view (patient's right)
            wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
            handleViewClick("right")
            break
          case "4":
            // Posterior view
            wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
            handleViewClick("back")
            break
          case "5":
            if (
              curRightPage === "UDAux" ||
              openStagingIPR ||
              openHistorySplitView
            )
              return
            onClickUpperLower(true)
            viewControlInTreatment.showArchMode("up")
            handleViewClick("split")
            break
          case "6":
            if (
              curRightPage === "UDAux" ||
              openStagingIPR ||
              openHistorySplitView
            )
              return
            onClickUpperLower(false)
            viewControlInTreatment.showArchMode("low")
            handleViewClick("split")

            break
          default:
            break
        }
      },
      [
        curArch,
        openInitialFinal,
        curRightPage,
        openStagingIPR,
        openHistorySplitView,
        dispatch,
        wasmModule.isFinishedOpencase,
      ],
    )
    useEffect(() => {
      window.addEventListener("keyup", handleKeyUp)
      return () => {
        window.removeEventListener("keyup", handleKeyUp)
      }
    }, [handleKeyUp])

    function getCaseMode(caseDisposition: string) {
      let caseMode = "NewCase"
      if (newCaseUDPlanStatus.includes(caseDisposition)) {
        if (isCasePreview) {
          caseMode = "NewCase"
        } else if (!ucloud1_1) {
          // use AI plan
          caseMode = "UDPlan"
        } else {
          caseMode = "NewCase"
        }
      } else if (uDModiStatus.includes(caseDisposition)) {
        caseMode = "UDModi"
      } else if (uDViewStatus.includes(caseDisposition)) {
        caseMode = "UDView"
      } else {
        caseMode = "UDView"
      }
      return caseMode
    }

    useEffect(() => {
      dispatch(setCurArch("all"))
    }, [])

    useEffect(() => {
      if (
        !isShowProgress &&
        isLoading == "succeeded" &&
        !isShowRefinementSplitScreenOnLoad.current
      ) {
        const urlParams = new URLSearchParams(window.location.search)
        const doRefinement = urlParams.get("doRefinement")
        if (doRefinement === "true") {
          if (planList?.length > 1) {
            setisDeletePlan(true)
            return
          }
          // if url has params doRefinement=true, then turn the edit mode on.
          // based on the 'take lock control', open the split screen to create refinement.
          switchEditViewHandle()
          isShowRefinementSplitScreenOnLoad.current = true
        }
      }
    }, [isShowProgress, isLoading, isWasmLoading])

    useEffect(() => {
      const caseDisposition = caseDetail.caseDisposition
      console.log("Current caseDisposition:" + caseDisposition)
      dispatch(setCurCaseMode(getCaseMode(caseDisposition)))
      setCurStatusString(caseDisposition)
    }, [caseDetail, ucloud1_1, isCasePreview])

    useEffect(() => {
      if (!wasmModule.isFinishedOpencase) {
        if (preview.isInitPreview()) {
          if (curArch === "all") preview.changeArchMode("both")
          else if (curArch === "up") preview.changeArchMode("up")
          else if (curArch === "low") preview.changeArchMode("low")
        }
        return
      }
      if (curArch === "all") viewControlInTreatment.showArchMode("all")
      else if (curArch === "up") viewControlInTreatment.showArchMode("up")
      else if (curArch === "low") viewControlInTreatment.showArchMode("low")

      dispatch(setZoomBarValue(100))

      const m = wasmModule.moduleManager.GetRelabelModule()
      if (!m)
        viewControlInTreatment.zoomWithValueInTreatment(ZoomBarValue / 100)
    }, [curArch])
    const onClickUpperLower = (upper: boolean) => {
      // check if there are duplicate labels before switching arch, only when relabel module is open
      if (openRelabel && relabelModule.IsExistSameLabel()) {
        setSameLabelDlg(true)
        return
      }

      // check if there are duplicate labels before switching arch, only when resegmentation module is open
      if (
        resegmentationModule.isResegmentationModuleOpened() &&
        resegmentationModule.isRelabelModuleOpened() &&
        (resegmentationModule.IsExistSameLabelForSingleJaw(0) ||
          resegmentationModule.IsExistSameLabelForSingleJaw(1))
      ) {
        setSameLabelDlg(true)
        return
      }

      const nextArch = upper
        ? curArch === "up"
          ? "all"
          : "up"
        : curArch === "low"
        ? "all"
        : "low"
      dispatch(setCurArch(nextArch))
    }

    useEffect(() => {
      if (switchViewEdit) {
        // console.log("🚀 ~ useEffect ~ location:", location)
        // 检�?hash 是否�?#uassit 结尾
        if (location.hash === "#uassist") {
          // clickUassist()
          clickUassistUpdate()
        }
      }
    }, [switchViewEdit])

    // Handle IPR edit mode when switching between view and edit modes
    useEffect(() => {
      if (!wasmModule.isFinishedOpencase) return

      if (switchViewEdit && openCollisionCheck) {
        gdsPlusSetup.EnterIPREditMode(openCollisionCheck)
      } else {
        gdsPlusSetup.EnterIPREditMode(false)
      }
    }, [switchViewEdit, openCollisionCheck])

    useEffect(() => {
      if (
        curRightPage === "UDAux" ||
        curRightPage === "fastsmart" ||
        curRightPage === "finetune"
      ) {
        dispatch(setOpenInitialFinal(false))
      }
      if (curRightPage === "UDAux" && openLiteMode) {
        dispatch(setOpenLiteMode(false))
      }
    }, [curRightPage])

    useEffect(() => {
      if (!wasmModule.isFinishedOpencase) return
      viewControlInTreatment.setSpacecheckVisibility(
        openCollisionCheck && !openHistorySplitView,
      )
      viewControlInTreatment.setOcclusionVisibility(
        openBiteCheck && !openHistorySplitView,
      )
      viewControlInTreatment.setSuperimposeVisibility(
        openSuperimpose && !openHistorySplitView,
      )
      const oldStatus =
        wasmModule.moduleManager != null &&
        wasmModule.moduleManager.GetInitialFinalDisplayModule() != null
      console.log(
        "oldStatus: ",
        oldStatus,
        ", openInitialFinal: ",
        openInitialFinal,
      )
      if (oldStatus != openInitialFinal) {
        initialfinal.setInitialFinalEnabled(
          openInitialFinal && !openHistorySplitView && !isCreateNewRefinement,
        )
      }

      //when open initial and final, hide the stage bar
      //close initial and final, show the stage bar
      if (openInitialFinal && !openHistorySplitView) {
        dispatch(setStageShowType(""))
        attachmentModule.openAttachmentModule(false)
      } else if (
        !openInitialFinal &&
        !openHistorySplitView &&
        !openStagingIPR
      ) {
        dispatch(setStageShowType("normal"))
        attachmentModule.openAttachmentModule(true)

        if (openLiteMode) {
          viewControlInTreatment.setAttachmentVisibility(!openLiteMode)
          viewControlInTreatment.specialToothColorToggle(!openLiteMode)
          viewControlInTreatment.hoverToothToggle(
            !openLiteMode && !openHistorySplitView,
          )
        }
      }
    }, [
      openCollisionCheck,
      openBiteCheck,
      openSuperimpose,
      openInitialFinal,
      openHistorySplitView,
    ])

    // Need to control grid switches individually
    useEffect(() => {
      if (!wasmModule.isFinishedOpencase) return
      viewControlInTreatment.setGridVisibility(
        openGrid && !openHistorySplitView,
      )
    }, [openGrid, openHistorySplitView])

    useEffect(() => {
      if (!wasmModule.isFinishedOpencase) return
      viewControlInTreatment.setAttachmentVisibility(!openLiteMode)
      viewControlInTreatment.specialToothColorToggle(!openLiteMode)
      viewControlInTreatment.hoverToothToggle(
        !openLiteMode && !openHistorySplitView,
      )
      //dispatch(setZoomBarValue(100))
      //viewControlInTreatment.zoomWithValueInTreatment(ZoomBarValue / 100)
    }, [openLiteMode, openHistorySplitView, currentTreatmentPlan])

    // Handle IPR edit mode when switching between view and edit modes
    useEffect(() => {
      if (!wasmModule.isFinishedOpencase) return

      if (switchViewEdit) {
        if (openCollisionCheck) {
          gdsPlusSetup.EnterIPREditMode(openCollisionCheck)
        }
      }
    }, [switchViewEdit, openCollisionCheck])

    const handleViewClick = (view) => {
      if (view === "split") {
        if (curRightPage === "UDSetup") {
          wasmModule.statusController.SwitchDomePonticMenu(false)
        }

        dispatch(setOpenInitialFinal(false))
        dispatch(setOpenGrid(false))
        dispatch(setOpenOrientation(false))
      }
      dispatch(setTopLeftViewType(view as ETopLeftViewType))
      viewControlInTreatment.setViewType(view)
    }
    const NewViewButtons = () => {
      const viewButtons = [
        {
          title: "Right",
          value: "right",
          disabled: false,
          icon: <ReactSVG src={NewRightIcon}></ReactSVG>,
        },
        {
          title: "Front",
          value: "front",
          disabled: false,
          icon: <ReactSVG src={NewFrontIcon}></ReactSVG>,
        },
        {
          title: "Back",
          value: "back",
          disabled: false,
          icon: <ReactSVG src={NewBackIcon}></ReactSVG>,
        },
        {
          title: "Left",
          value: "left",
          disabled: false,
          icon: <ReactSVG src={NewLeftIcon}></ReactSVG>,
        },
        {
          title: "Split",
          value: "split",
          disabled: false,
          icon: <ReactSVG src={NewSplitIcon}></ReactSVG>,
        },
      ]
      const handleClick = (view) => {
        if (view === "split") {
          if (curRightPage === "UDSetup") {
            wasmModule.statusController.SwitchDomePonticMenu(false)
          }

          dispatch(setOpenInitialFinal(false))
          dispatch(setOpenGrid(false))
          dispatch(setOpenOrientation(false))
        }
        dispatch(setTopLeftViewType(view))
        viewControlInTreatment.setViewType(view)
      }
      return (
        <>
          {viewButtons.map(({ title, value, disabled, icon }, index) => {
            if (value === "split" && isCreateNewRefinement) {
              return null
            }
            if (value === "split" && openHistorySplitView) {
              return null
            }

            disabled =
              value === "split" && (curRightPage === "UDAux" || openStagingIPR)
            return (
              <Tooltip key={index} title={title} placement="bottom">
                <ToggleButton
                  disabled={disabled} // disable split view when auxillary page is open
                  sx={{
                    paddingBottom: 1,
                    border: "none",
                    borderRadius: "8px",
                    "&:hover": {
                      borderRadius: "8px",
                    },
                    "&.Mui-selected": {
                      borderRadius: "8px",
                    },
                    "&.Mui-disabled": {
                      border: "none",
                      boxShadow: "none",
                      "& .MuiTouchRipple-root": {
                        display: "none",
                      },
                      // backgroundColor: "gray",
                    },
                  }}
                  value={value}
                  size="large"
                  onClick={() => handleViewClick(value)}
                >
                  {icon}
                </ToggleButton>
              </Tooltip>
            )
          })}
        </>
      )
    }

    const onClickSaveCase = (e, isviewMode?: boolean) => {
      onclickCloseBtn(() => {
        if (!isShowAssign && isviewMode && !isEdit) {
          safeCloseWindow()
          return
        }
        let path = "/patients"
        if (from === "bundle" || location.hash === "#uassist") {
          console.log("location :", location.hash)
          path = "/patients"
        }
        navigate(path)
      })
    }
    const NewToolButtons = () => {
      const toolButtons = [
        {
          title: "Collision Check",
          key: "collision",
          disabled: openStagingIPR,
          selected: openCollisionCheck,
          icon: (
            <ReactSVG
              src={NewIPRIcon}
              afterInjection={(svg) => {
                const path = svg.getElementsByTagName("path")[0]
                const path1 = svg.getElementsByTagName("path")[1]
                const line = svg.getElementsByTagName("line")[0]
                if (openCollisionCheck) {
                  path?.setAttribute("stroke", "#215ECD")
                  path1?.setAttribute("stroke", "#215ECD")
                  line?.setAttribute("stroke", "#215ECD")
                } else {
                  path?.setAttribute("stroke", "#707070")
                  path1?.setAttribute("stroke", "#707070")
                  line?.setAttribute("stroke", "#707070")
                }
              }}
            ></ReactSVG>
          ),
        },
        {
          title: "Bite check",
          key: "bitecheck",
          // disabled: disabledBiteCheck, //If Bite Check needs to be disabled, comment out this line
          disabled: false,
          selected: openBiteCheck,
          icon: (
            <ReactSVG
              src={NewOccIcon}
              afterInjection={(svg) => {
                const path = svg.getElementsByTagName("path")[0]
                const path1 = svg.getElementsByTagName("path")[1]
                const path2 = svg.getElementsByTagName("path")[2]
                const rect = svg.getElementsByTagName("rect")[0]
                if (openBiteCheck) {
                  path?.setAttribute("stroke", "#215ECD")
                  path1?.setAttribute("stroke", "#215ECD")
                  path2?.setAttribute("fill", "#215ECD")
                  rect?.setAttribute("fill", "#215ECD")
                } else {
                  path?.setAttribute("stroke", "#707070")
                  path1?.setAttribute("stroke", "#707070")
                  path2?.setAttribute("fill", "#707070")
                  rect?.setAttribute("fill", "#215ECD")
                }
              }}
            />
          ),
        },
        {
          title: "Superimpose",
          key: "superimpose",
          disabled: false,
          selected: openSuperimpose,
          icon: (
            <ReactSVG
              src={NewSuperimpositionIcon}
              afterInjection={(svg) => {
                const path = svg.getElementsByTagName("path")[0]
                const path1 = svg.getElementsByTagName("path")[1]
                if (openSuperimpose) {
                  path?.setAttribute("stroke", "#215ECD")
                  path1?.setAttribute("stroke", "#215ECD")
                } else {
                  path?.setAttribute("stroke", "#707070")
                  path1?.setAttribute("stroke", "#707070")
                }
              }}
            ></ReactSVG>
          ),
        },
        {
          title: "Initial Final",
          key: "initialfinal",
          disabled: openStagingIPR,
          selected: openInitialFinal,
          icon: (
            <ReactSVG
              src={NewInitialFinalIcon}
              afterInjection={(svg) => {
                const path = svg.getElementsByTagName("path")[0]
                if (openInitialFinal) {
                  path?.setAttribute("fill", "#215ECD")
                  path?.setAttribute("fill-opacity", "1")
                } else {
                  path?.setAttribute("fill", "black")
                  path?.setAttribute("fill-opacity", "0.56")
                }
              }}
            ></ReactSVG>
          ),
        },
        {
          title: "Grid",
          key: "grid",
          disabled: false,
          selected: openGrid,
          icon: (
            <ReactSVG
              src={NewGridIcon}
              afterInjection={(svg) => {
                const path = svg.getElementsByTagName("path")[0]
                if (openGrid) {
                  path?.setAttribute("fill", "#215ECD")
                  path?.setAttribute("fill-opacity", "1")
                } else {
                  path?.setAttribute("fill", "black")
                  path?.setAttribute("fill-opacity", "0.56")
                }
              }}
            ></ReactSVG>
          ),
        },

        {
          title: "Show or Hide",
          key: "litemode",
          disabled: false,
          selected: openLiteMode,
          icon: (
            <ReactSVG
              src={NewLightmodeIcon}
              afterInjection={(svg) => {
                const path = svg.getElementsByTagName("path")[0]
                if (openLiteMode) {
                  path?.setAttribute("fill", "#215ECD")
                  path?.setAttribute("fill-opacity", "1")
                } else {
                  path?.setAttribute("fill", "black")
                  path?.setAttribute("fill-opacity", "0.56")
                }
              }}
            ></ReactSVG>
          ),
        },
      ]

      const handleClick = (toolName) => {
        switch (toolName) {
          case "collision":
            if (!openCollisionCheck) dispatch(setOpenInitialFinal(false))
            dispatch(setOpenCollisionCheck(!openCollisionCheck))
            // viewControlInTreatment.setSpacecheckVisibility(!openCollisionCheck)
            break
          case "bitecheck":
            if (!openBiteCheck) {
              dispatch(setOpenInitialFinal(false))
              toothMovement.switchModuleFastSmartCircle(false)
              toothMovement.switchModuleFineTuneCircle(false)
            }
            dispatch(setOpenBiteCheck(!openBiteCheck))
            break
          case "superimpose":
            if (!openSuperimpose) dispatch(setOpenInitialFinal(false))
            dispatch(setopenSuperimpose(!openSuperimpose))
            break
          case "initialfinal":
            if (!openInitialFinal) {
              dispatch(setopenSuperimpose(false))
              dispatch(setOpenBiteCheck(false))
            }
            dispatch(setOpenInitialFinal(!openInitialFinal))
            break
          case "grid":
            if (!openGrid) viewControlInTreatment.setViewType("front")
            dispatch(setOpenGrid(!openGrid))
            break
          case "litemode":
            if (!openLiteMode) dispatch(setOpenInitialFinal(false))
            dispatch(setOpenLiteMode(!openLiteMode))
            break
        }
      }

      return (
        <>
          {toolButtons.map(
            ({ title, key, disabled, icon, selected }, index) => {
              return (
                <Tooltip
                  style={{ backgroundColor: selected ? "lightgray" : "" }}
                  key={index}
                  title={title}
                  placement="bottom"
                >
                  <ToggleButton
                    className={classNames("", {
                      "my-disabled": disabled,
                    })}
                    sx={{
                      paddingBottom: 1,
                      border: "none!important",
                      borderRadius: "8px",
                      "&:hover": {
                        borderRadius: "8px",
                      },
                      "&.Mui-selected": {
                        borderRadius: "8px",
                      },
                    }}
                    value={key}
                    size="large"
                    disabled={disabled}
                    onClick={() => handleClick(key)}
                  >
                    {icon}
                  </ToggleButton>
                </Tooltip>
              )
            },
          )}
        </>
      )
    }

    const checkShowUpperLowerIcons = () => {
      if (curCaseMode === "NewCase") {
        if (hasUploadSTLs[0] && hasUploadSTLs[1]) return true
        else return false
      } else return true
    }

    const CaseModeBtn = () => {
      const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
      const open = Boolean(anchorEl)
      const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
      }
      const handleSelect = (e: any, statusType: string) => {
        dispatch(setCurCaseMode(statusType))
        dispatch(setSwitchViewEdit(statusType === "WeDesign"))
      }
      const handleClose = () => {
        setAnchorEl(null)
      }
      return (
        <>
          <Tooltip title="Status" placement="bottom">
            <IconButton
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <StatusIcon />
            </IconButton>
          </Tooltip>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={(e) => handleSelect(e, "NewCase")}>
              New Case
            </MenuItem>
            <MenuItem onClick={(e) => handleSelect(e, "UDPlan")}>
              uDesign
            </MenuItem>
            <MenuItem onClick={(e) => handleSelect(e, "UDModi")}>
              Reivew & Modi
            </MenuItem>
            <MenuItem onClick={(e) => handleSelect(e, "UDView")}>
              View Only
            </MenuItem>
            <MenuItem onClick={(e) => handleSelect(e, "WeDesign")}>
              WeDesign
            </MenuItem>
            <Divider />
            <MenuItem>Case_status: {curStatusString}</MenuItem>
          </Menu>
        </>
      )
    }

    const WorkflowBtn = () => {
      const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
      const open = Boolean(anchorEl)
      const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
      }
      const handleSelect = (e: any, caseType: string) => {
        dispatch(setWorkflowMode(caseType))
      }
      const handleClose = () => {
        dispatch(setWorkflowMode("aidesign"))
        setAnchorEl(null)
      }
      return (
        <>
          {/*
        <Tooltip title="Workflow" placement="bottom">
          <IconButton
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <WorkflowIcon />
          </IconButton>
        </Tooltip>*/}
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={(e) => handleSelect(e, "aidesign")}>
              AI Design
            </MenuItem>
            <MenuItem onClick={(e) => handleSelect(e, "smartrx")}>
              Smart Rx
            </MenuItem>
            <MenuItem onClick={(e) => handleSelect(e, "retainerrx")}>
              Retainer Rx
            </MenuItem>
          </Menu>
        </>
      )
    }

    // click uassit button will check photo first
    const { photoTypeJson } = useAppSelector(
      (state: RootState) => state.PhotosService,
    )
    const [noPhotoObj, setNophotoObj] = useState<{
      open: boolean
      info: string
    }>({ open: false, info: "" })
    const [resetCompleted, setResetCompleted] = useState(false)
    // click uassist button function
    const handleUassistClick = () => {
      dispatch(resetSchema())
      dispatch(resetPrescriptionSchema())
      dispatch(resetRxRefinementFormEdit())
      dispatch(resetRxRefinementFormAdd())
      dispatch(setSmartRxShow(false))
      if (isCasePreview && caseDisposition === "REJECTED") {
        dispatch(setCurLeftPage("records"))
      } else {
        dispatch(setCurLeftPage(""))
      }
      dispatch(setUassistRxShow(false))
      // After dispatches, update the state flag
      setResetCompleted(true)
    }
    useEffect(() => {
      if (resetCompleted) {
        // clickUassist()
        clickUassistUpdate()
        // Reset flag to prevent repeated calls if needed
        setResetCompleted(false)
      }
    }, [resetCompleted]) // Effect will run once the flag changes

    // click uassist function update => uassist_progress displays a pop-up menu when it is either ready or refinement_ready.
    const clickUassistUpdate = () => {
      const { hasAnyphotos, hasPhotos, hasXrays } =
        getResultByPhotoJson(photoTypeJson)
      const { normalPosition, xrayPosition } = checkIsThereASpecifiedPhoto(
        photoTypeJson || {},
      )
      // if (
      //   !udesign_category?.includes("A") &&
      //   [UASSIST_STATUS.COMPLETED, UASSIST_STATUS.REFINEMENT_READY].includes(
      //     uassist_progress,
      //   )
      // ) {
      //   setShowNoUassistRetainerPopup(true)
      //   return
      // }
      if (
        uassist_progress === UASSIST_STATUS.IN_PROGRESS ||
        uassist_progress === UASSIST_STATUS.COMPLETED
      ) {
        setShowNoUassistPopup(true)
        return
      }
      if (uassist_progress === UASSIST_STATUS.READY && planList.length > 1) {
        setisDeletePlan(true)
        return
      }

      if (
        uassist_progress === UASSIST_STATUS.READY &&
        stageControl.getMaxStageNodeIndex() > 0
      ) {
        setOpenUassist(true)
        return
      }

      if (
        uassist_progress === UASSIST_STATUS.READY &&
        !(stageControl.getMaxStageNodeIndex() > 0)
      ) {
        //if (!udesign_category?.includes("A")) {
        //   if (!normalPosition && !xrayPosition) {
        //     dispatch(setCurLeftPage("records"))
        //   }
        //   dispatch(setUassistRxShow(true))
        // } else {
        //   setOpenUassist(true)
        // }
        // return
        setOpenUassist(true)
        return
      }
      if (uassist_progress === UASSIST_STATUS.REFINEMENT_READY) {
        if (planList.length > 1) {
          setisDeletePlan(true)
        } else {
          // if (
          //   !caseDetail.is_existing_plan_uassist_possible ||
          //   [ 
          //     CASE_STATUS.FILL_OUT_RX_FORM,
          //     CASE_STATUS.SUBMIT_TO_UASSIST,
          //   ].includes(caseDetail.caseDisposition)
          // ) {
          //   dispatch(openRefinement({ isSelfplan: false }))
          // } else {
          //   setOpenUassist(true)
          // }
            setOpenUassist(true)
        }
        return
      }
    }
    const orderHandle = () => {
      const callback = () => {
        navigate(`/order/patient/${patientId}/case/${caseId}/bundle`)
      }
      callbackAfterIPRcheck = callback
      checkIfNeedMsgBeforePrintOrOrder(callback)
    }

    const onClickPrint = () => {
      const callback = () => {
        wasmModule.statusController.ResizeRenderer(0.4)
        dispatch(setOpenOrderSplit(true))
        dispatch(setOpenStlPrint(true))
        dispatch(setSmartRxShow(false)) // close smart rx panel
        dispatch(setCurRightPage("")) // close right page
      }
      callbackAfterIPRcheck = callback
      checkIfNeedMsgBeforePrintOrOrder(callback, true)
    }

    // 弹框判断流程
    // 1. 是否有文件更新，需要弹框提示case需要update
    // 2. 如果在edit模式并且tx数据修改,需要弹框提示保存，保存后才走下一步，否则退出流程�?
    //    如果非edit模式则直接走下一�?
    // 3. 请求lock,
    // 4. lock成功后重置order状态，判断case是否是已经下了order的状态，判断多方案弹窗，判断IPR弹窗，全部通过后才下一�?
    // This function is used to check if there are any popup message before printing or ordering
    const checkIfNeedMsgBeforePrintOrOrder = (
      callback: () => void,
      isCheckPrint: boolean = false,
    ) => {
      // 锁case并且检查IPR
      const resetStateAndCheckIPR = () => {
        //  Order Submitted' or 'In Production.状态时，view模式可直接打�?
        if (isCheckPrint && orderButtonPopUpTmp.includes(caseDisposition)) {
          // print中stage组件依赖了orderSlice状态，这里需要重置orderSlice状�?
          dispatch(resetOrder())
          if (from) {
            dispatch(setOrderSource(from))
          }
          if (planList.length === 1) {
            dispatch(setData({ loading: "pending" }))
            setTimeout(() => {
              const checkIprStr =
                wasmModule.statusController.checkCollisionWithIPR(NumberSystem)
              dispatch(setData({ loading: "succeeded" }))
              if (checkIprStr !== "") {
                setCheckIPRobj({
                  show: true,
                  showDetail: false,
                  detail: checkIprStr,
                })
                return
              }
              callback && callback()
            }, 500)
          }
        } else {
          const clickwho = isCheckPrint ? "print" : "order"
          requestLock(() => {
            dispatch(resetOrder())

            if (from) {
              dispatch(setOrderSource(from))
            }

            // popup lock-case
            if (orderButtonPopUpTmp.includes(caseDisposition)) {
              setLockType(1)
              setOpenLockPopup(true)
              return
            }
            setisClickOrder(true)
            // if there are more than one plan, then popup will stop the order or print.
            if (planList.length > 1) {
              setispopupAfterOrder(true)
              return
            }
            if (planList.length === 1) {
              dispatch(setData({ loading: "pending" }))
              setTimeout(() => {
                const checkIprStr =
                  wasmModule.statusController.checkCollisionWithIPR(
                    NumberSystem,
                  )
                dispatch(setData({ loading: "succeeded" }))
                if (checkIprStr !== "") {
                  setCheckIPRobj({
                    show: true,
                    showDetail: false,
                    detail: checkIprStr,
                  })
                  return
                }
                callback && callback()
              }, 500)
            }
          }, clickwho)
        }
      }

      const isTxDataChanged = caseManagement.getTxDataChanged()
      dispatch(
        fetchFileList({
          patientId,
          caseId,
          fileNames: FILEZIPS,
          checkFileUpdates: true,
        }),
      ).then((res) => {
        if (res.payload?.result?.length) {
          const updatedFiles = res.payload.result
            .filter((file) => file.attachment_type === "cases")
            .map((file) => ({
              name: file.file_name,
              time: file.updated_date,
            }))
          const isCaseUpdated = hasFileHistoryChanged(
            fileHistory[caseId],
            updatedFiles,
          )
          if (isCaseUpdated) {
            setShowcaseUpdatedModal(isCaseUpdated)
          } else {
            //check the stage data is changed or not, if changed, save it by user selection, else go order
            if (switchViewEdit && isTxDataChanged) {
              dispatch(setSelectTxButton(1))
              dispatch(setSelectTxDataSave("save_show"))
              userSelectTxChangeSave().then((result) => {
                if (result === "save_cancel") {
                  return
                }
                resetStateAndCheckIPR()
              })
            } else {
              resetStateAndCheckIPR()
            }
          }
        }
      })
    }
    const switchEditViewHandle = () => {
      if (!switchViewEdit) {
        dispatch(
          fetchFileList({
            patientId,
            caseId,
            fileNames: FILEZIPS,
            checkFileUpdates: true,
          }),
        ).then((res) => {
          if (res.payload?.result?.length) {
            const updatedFiles = res.payload.result
              .filter((file) => file.attachment_type === "cases")
              .map((file) => ({
                name: file.file_name,
                time: file.updated_date,
              }))
            const isCaseUpdated = hasFileHistoryChanged(
              fileHistory[caseId],
              updatedFiles,
            )
            if (isCaseUpdated) {
              setShowcaseUpdatedModal(isCaseUpdated)
            } else {
              switchEditCallBack()
            }
          }
        })
      } else {
        switchEditCallBack()
      }
    }
    // start refinement prompt
    const [openStartRefinement, setOpenStartRefinement] =
      useState<boolean>(false)
    // click self-refinement
    const clickSelfRefinement = () => {
      const callBack = () => {
        if (planList.length > 1) {
          setisDeletePlan(true)
        } else {
          dispatch(setSmartRxShow(false)) // close smart rx panel
          dispatch(setCurRightPage("")) // close right page
          dispatch(openRefinement({ isSelfplan: true }))
        }
      }
      commonLockFunction(callBack, "selfRefinement")
    }
    // common lock first function  点击uassist、self-refinement、submit uassist 都需先做一系列判断且lock case
    const commonLockFunction = (callBack: () => void, clickWho: string) => {
      const lockCase = () => {
        requestLock(() => {
          callBack()
        }, clickWho)
      }

      const isTxDataChanged = caseManagement.getTxDataChanged()
      dispatch(
        fetchFileList({
          patientId,
          caseId,
          fileNames: FILEZIPS,
          checkFileUpdates: true,
        }),
      ).then((res) => {
        if (res.payload?.result?.length) {
          const updatedFiles = res.payload.result
            .filter((file) => file.attachment_type === "cases")
            .map((file) => ({
              name: file.file_name,
              time: file.updated_date,
            }))
          const isCaseUpdated = hasFileHistoryChanged(
            fileHistory[caseId],
            updatedFiles,
          )
          if (isCaseUpdated) {
            setShowcaseUpdatedModal(isCaseUpdated)
          } else {
            //check the stage data is changed or not, if changed, save it by user selection, else go order
            if (switchViewEdit && isTxDataChanged) {
              dispatch(setSelectTxButton(1))
              dispatch(setSelectTxDataSave("save_show"))
              userSelectTxChangeSave().then((result) => {
                if (result === "save_cancel") {
                  return
                }
                lockCase()
              })
            } else {
              lockCase()
            }
          }
        }
      })
    }
    // click Use Existing Scan/Plan - Submit to uAssist, Refinement - Submit to uAssist . 前奏跟点击uassist 一样，只是具体执行时候只需要执行各自功�?
    const clickSubmitCommon = (isUse: boolean) => {
      // 先关闭一些窗�?或者打开一些窗�?
      dispatch(resetSchema())
      dispatch(resetPrescriptionSchema())
      dispatch(resetRxRefinementFormEdit())
      dispatch(resetRxRefinementFormAdd())
      dispatch(setSmartRxShow(false))
      if (isCasePreview && caseDisposition === "REJECTED") {
        dispatch(setCurLeftPage("records"))
      } else {
        dispatch(setCurLeftPage(""))
      }
      dispatch(setUassistRxShow(false))
      // 再执行其中点击事�?
      const { hasAnyphotos, hasPhotos, hasXrays } =
        getResultByPhotoJson(photoTypeJson)
      const { normalPosition, xrayPosition } = checkIsThereASpecifiedPhoto(
        photoTypeJson || {},
      )
      // if (
      //   !udesign_category?.includes("A") &&
      //   [UASSIST_STATUS.COMPLETED, UASSIST_STATUS.REFINEMENT_READY].includes(
      //     uassist_progress,
      //   )
      // ) {
      //   setShowNoUassistRetainerPopup(true)
      //   return
      // }
      if (
        uassist_progress === UASSIST_STATUS.IN_PROGRESS ||
        uassist_progress === UASSIST_STATUS.COMPLETED
      ) {
        setShowNoUassistPopup(true)
        return
      }
      if (uassist_progress === UASSIST_STATUS.READY && planList.length > 1) {
        setisDeletePlan(true)
        return
      }
      if (
        uassist_progress === UASSIST_STATUS.READY &&
        stageControl.getMaxStageNodeIndex() > 0
      ) {
        if (isUse) {
          if (!normalPosition && !xrayPosition) {
            dispatch(setCurLeftPage("records"))
          }
          dispatch(setUassistRxShow(true))
        } else {
          dispatch(openRefinement({ isSelfplan: false }))
        }

        return
      }

      if (
        uassist_progress === UASSIST_STATUS.READY &&
        !(stageControl.getMaxStageNodeIndex() > 0)
      ) {
        if (isUse) {
          if (!normalPosition && !xrayPosition) {
            dispatch(setCurLeftPage("records"))
          }
          dispatch(setUassistRxShow(true))
        } else {
          // if (!udesign_category?.includes("A")) {
          //   setShowNoUassistRetainerPopup(true)
          //   return
          // }
          dispatch(openRefinement({ isSelfplan: false }))
        }

        return
      }
      if (uassist_progress === UASSIST_STATUS.REFINEMENT_READY) {
        if (planList.length > 1) {
          setisDeletePlan(true)
        } else {
          if (isUse) {
            if (!normalPosition && !xrayPosition) {
              dispatch(setCurLeftPage("records"))
            }
            dispatch(setUassistRxShow(true))
          } else {
            // if (!udesign_category?.includes("A")) {
            //   setShowNoUassistRetainerPopup(true)
            //   return
            // }
            dispatch(openRefinement({ isSelfplan: false }))
          }
        }
        return
      }
    }
    return (
      <Paper
        sx={{
          left: 16,
          top: 43,
          right: 16,
          height: "58px",
          backgroundColor: "transparent",
          justifyContent: "center",
          position: "absolute",
        }}
        elevation={0}
      >
        <CaseUpdatedModal
          showModal={showCaseUpdatedModal}
          setShowModal={setShowcaseUpdatedModal}
        />
        <Stack
          direction="row"
          sx={{ height: "100%" }}
          alignItems={"center"}
          spacing={1}
        >
          <PatientNameID
            firstName={firstName}
            lastName={lastName}
            caseId={caseId}
            patientId={patientId}
            creatDate={
              caseDetail.createDate
                ? `$${dateFormat(caseDetail.createDate, "MM/DD/YY")}`
                : ""
            }
          />
          <Box sx={{ flexGrow: 1 }} />
          {!widthAll && (
            <Stack
              sx={{
                position: "absolute",
                top: "50%",
                left: isCreateNewRefinement ? "20%" : "50%",
                transform: "translate(-50%, -50%)",
                justifyContent: "center",
              }}
              direction={"row"}
              spacing={2}
            >
              {checkShowUpperLowerIcons() &&
                !openOrientation &&
                !showJsPreview && (
                  <Stack
                    sx={{
                      height: "48px",
                      borderRadius: "8px",
                      backgroundColor: theme.transBkColor.light,
                      boxShadow: 3,
                      zIndex: 20,
                    }}
                    direction={"row"}
                  >
                    <Tooltip
                      style={{
                        backgroundColor: curArch === "up" ? "lightgray" : "",
                      }}
                      title="Upper"
                      placement="bottom"
                    >
                      <ToggleButton
                        disabled={singleArchBool || disabledUpper}
                        sx={{
                          border: "none",
                          borderRadius: "8px",
                          "&:hover": {
                            borderRadius: "8px",
                          },
                          "&.Mui-selected": {
                            borderRadius: "8px",
                          },
                          ":disabled": {
                            border: "none",
                          },
                        }}
                        value="showUpper"
                        size="large"
                        onClick={() => onClickUpperLower(true)}
                      >
                        <ReactSVG
                          src={NewUpperIcon}
                          afterInjection={(svg) => {
                            const path = svg.getElementsByTagName("path")[0]
                            if (curArch === "up") {
                              path?.setAttribute("fill", "#215ECD")
                              path?.setAttribute("fill-opacity", "1")
                            } else {
                              path?.setAttribute("fill", "black")
                              path?.setAttribute("fill-opacity", "0.56")
                            }
                          }}
                        ></ReactSVG>
                      </ToggleButton>
                    </Tooltip>
                    <Tooltip
                      style={{
                        backgroundColor: curArch === "low" ? "lightgray" : "",
                      }}
                      title="Lower"
                      placement="bottom"
                    >
                      <ToggleButton
                        disabled={singleArchBool || disabledLower}
                        sx={{
                          border: "none",
                          borderRadius: "8px",
                          "&:hover": {
                            borderRadius: "8px",
                          },
                          "&.Mui-selected": {
                            borderRadius: "8px",
                          },
                          ":disabled": {
                            border: "none",
                          },
                        }}
                        value="showLower"
                        size="large"
                        onClick={() => onClickUpperLower(false)}
                      >
                        <ReactSVG
                          src={NewLowerIcon}
                          afterInjection={(svg) => {
                            const path = svg.getElementsByTagName("path")[0]
                            if (curArch === "low") {
                              path?.setAttribute("fill", "#215ECD")
                              path?.setAttribute("fill-opacity", "1")
                            } else {
                              path?.setAttribute("fill", "black")
                              path?.setAttribute("fill-opacity", "0.56")
                            }
                          }}
                        ></ReactSVG>
                      </ToggleButton>
                    </Tooltip>
                    {!isCasePreview &&
                      !startAutoModelCheck &&
                      !isOpenModelCheck &&
                      !showJsPreview && <NewViewButtons />}
                  </Stack>
                )}

              {!isCasePreview &&
                !isCreateNewRefinement &&
                !isOpenModelCheck &&
                !showJsPreview && (
                  <Stack
                    sx={{
                      height: 48,
                      borderRadius: 2,
                      backgroundColor: theme.transBkColor.light,
                      boxShadow: 3,
                    }}
                    direction={"row"}
                  >
                    {!openHistorySplitView && !startAutoModelCheck && (
                      <NewToolButtons />
                    )}
                  </Stack>
                )}

              {!showJsPreview && <ZoomBar />}
            </Stack>
          )}

          <Box sx={{ flexGrow: 1 }} />
          {!user.isAllowToViewAllOrg && (
            <Fragment>
              {ucloud1_1 &&
                !startAutoModelCheck &&
                !isDoingPresetup &&
                caseDisposition !== "ATTENTION_NEEDED" && (
                  <>
                    <Switch
                      checked={switchViewEdit}
                      onChange={async () => {
                        //close the Passive Aligner/stage IPR/velocity
                        if (
                          SCCallbackManager.getInstance().getAsyncCheckingBeforeQuitIprCallBack()
                        ) {
                          const checkResult =
                            await SCCallbackManager.getInstance().getAsyncCheckingBeforeQuitIprCallBack()()
                          if (checkResult === "cancel") {
                            return
                          }
                          if (
                            SCCallbackManager.getInstance().getAsyncQuitStagingCallBack()
                          ) {
                            await SCCallbackManager.getInstance().getAsyncQuitStagingCallBack()()
                          }
                        }

                        const isTxDataChanged =
                          caseManagement.getTxDataChanged()
                        //check the stage data is changed or not, if changed, save it by user selection, else go order
                        if (switchViewEdit && isTxDataChanged) {
                          dispatch(setSelectTxButton(1))
                          dispatch(setSelectTxDataSave("save_show"))
                          userSelectTxChangeSave().then((result) => {
                            if (result === "save_cancel") {
                              return
                            }
                            switchEditViewHandle()
                          })
                        } else {
                          switchEditViewHandle()
                        }
                      }}
                      sx={{
                        visibility:
                          openHistorySplitView || isOpenModelCheck
                            ? "hidden"
                            : "visible",
                      }}
                    ></Switch>
                    <Typography
                      variant="body2"
                      color={"white"}
                      sx={{
                        visibility:
                          openHistorySplitView || isOpenModelCheck
                            ? "hidden"
                            : "visible",
                        marginLeft: "0px !important",
                      }}
                    >
                      Edit
                    </Typography>
                  </>
                )}

              <Tooltip
                title={
                  <p style={{ margin: "0" }}>
                    Submit initial case,
                    <br />
                    Submit refinement or <br /> New scan for final retainer
                  </p>
                }
              >
                <Fab
                  variant="extended"
                  size="large"
                  onClick={() => {
                    commonLockFunction(handleUassistClick, "uassist")
                  }}
                  sx={{
                    marginRight: "15px",
                    minWidth: 62,
                    height: 40,
                    zIndex: 1,
                    visibility:
                      openHistorySplitView ||
                      startAutoModelCheck ||
                      isOpenModelCheck ||
                      isDoingPresetup
                        ? "hidden"
                        : "visible",
                    backgroundColor: "rgba(255, 255, 255, 0.85)",
                    ":hover": {
                      backgroundColor: "#F5F5F5",
                    },
                    "&:disabled svg": {
                      color: "black",
                      opacity: 0.38,
                    },
                  }}
                  aria-label="uAssist"
                  disabled={
                    orderButtonPopUpTmp.includes(caseDisposition) ||
                    ([CASE_STATUS.REJECTED].includes(caseDisposition) &&
                      ![upperType, lowerType].includes("A"))
                  }
                >
                  <Typography variant="inherit">
                    {t("button.uassist")}
                  </Typography>
                  {windowWidth > 1600 && (
                    <Person sx={{ ml: 1 }} color="action" />
                  )}
                </Fab>
              </Tooltip>
              {/* <Button
                sx={{
                  visibility:
                    openHistorySplitView ||
                    startAutoModelCheck ||
                    isOpenModelCheck ||
                    isDoingPresetup
                      ? "hidden"
                      : "visible",
                  zIndex: 1,
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  minWidth: 40,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.85);",
                  boxShadow:
                    "0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)",
                  ":hover": {
                    backgroundColor: "rgba(245, 245, 245, 0.96);",
                    boxShadow:
                      "0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)",
                  },
                  ":disabled": {
                    backgroundColor: "rgba(0, 0, 0, 0.12)",
                  },
                  "&:disabled svg": {
                    color: "black",
                    opacity: 0.38,
                  },
                }}
                onClick={() => {
                  setOpenStartRefinement(true)
                }}
              >
                <CachedIcon
                  sx={{
                    color: "black",
                    opacity: 0.56,
                  }}
                />
              </Button> */}
              {/* {hasAny(UI_PERMISSION.UI_PRINT_CREATE) && (
                <Button
                  // 1. if case is preview or right tool page is open, disable print button
                  // 2. if case is not preview, check the permission from backend to enable or disable print button
                  disabled={
                    isCasePreview || curRightPage ? true : !is_printable
                  }
                  sx={{
                    visibility:
                      openHistorySplitView ||
                      startAutoModelCheck ||
                      isOpenModelCheck ||
                      isDoingPresetup
                        ? "hidden"
                        : "visible",
                    zIndex: 1,
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    minWidth: 40,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.85);",
                    boxShadow:
                      "0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)",
                    ":hover": {
                      backgroundColor: "rgba(245, 245, 245, 0.96);",
                      boxShadow:
                        "0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)",
                    },
                    ":disabled": {
                      backgroundColor: "rgba(0, 0, 0, 0.12)",
                    },
                    "&:disabled svg": {
                      color: "black",
                      opacity: 0.38,
                    },
                  }}
                  onClick={() => onClickPrint()}
                >
                  <LocalPrintshopIcon
                    sx={{
                      color: "black",
                      opacity: 0.56,
                    }}
                  />
                </Button>
              )} */}
              <Tooltip title={`Order Aligners or Retainers`}>
                <Button
                  onClick={() => {
                    orderHandle()
                  }}
                  sx={{
                    marginRight: "15px",
                    zIndex: 1,
                    visibility:
                      openHistorySplitView ||
                      startAutoModelCheck ||
                      isOpenModelCheck ||
                      isDoingPresetup
                        ? "hidden"
                        : "visible",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    minWidth: 40,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#215ECD",
                    boxShadow:
                      "0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)",
                    ":hover": {
                      backgroundColor: "#1E88E5",
                      boxShadow:
                        "0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)",
                    },
                    ":disabled": {
                      backgroundColor: "rgba(0, 0, 0, 0.12)",
                    },
                    "& svg": {
                      color: "white",
                    },
                    "&:disabled svg": {
                      color: "black",
                      opacity: 0.38,
                    },
                  }}
                  disabled={isCasePreview ? true : !is_orderable}
                >
                  <ShoppingCartIcon
                    sx={{
                      color: "white",
                    }}
                  />
                </Button>
              </Tooltip>

              {openHistorySplitView ||
              startAutoModelCheck ||
              isOpenModelCheck ||
              isDoingPresetup ? (
                <></>
              ) : (
                <MenuButtons
                  onClickPrint={onClickPrint}
                  clickSelfRefinement={clickSelfRefinement}
                  clickUseUassist={() => {
                    commonLockFunction(() => {
                      clickSubmitCommon(true)
                    }, "submit to uassist")
                  }}
                  clickRefinementUassist={() => {
                    commonLockFunction(() => {
                      clickSubmitCommon(false)
                    }, "refinement- subimt to uassist")
                  }}
                />
              )}
            </Fragment>
          )}
        </Stack>
        <DialogBox
          open={noPhotoObj.open}
          title={"Warning"}
          content={<>{`Please check photos`}</>}
          actions={
            <UButton
              onClickHandler={() => {
                setNophotoObj({ open: false, info: "" })
              }}
              variant={"contained"}
              btnText={t("treat.lockPopUp.okbtn")}
            />
          }
        />
        <Dialog open={openUassist}>
          <DialogTitle sx={{ padding: "16px 24px" }}>
            <Typography variant="inherit" color={"rgba(0, 0, 0, 0.87)"}>
              {t("treat.uAssistPopup.title")}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography
              sx={{ marginTop: "20px" }}
              variant="body1"
              color={"#000"}
            >
              {t("treat.uAssistPopup.content")}
            </Typography>
            <Box component={"div"} sx={{ display: "flex", marginTop: "16px" }}>
              <Box width={248} sx={{ marginRight: "16px" }}>
                <Box
                  onClick={() => {
                    if (!caseDetail?.is_existing_plan_uassist_possible) {
                      return
                    }
                    dispatch(setUassistRxShow(true))
                    const { normalPosition, xrayPosition } =
                      checkIsThereASpecifiedPhoto(photoTypeJson || {})
                    if (!normalPosition && !xrayPosition) {
                      dispatch(setCurLeftPage("records"))
                    }
                    setOpenUassist(false)
                  }}
                  sx={{
                    cursor: !caseDetail?.is_existing_plan_uassist_possible
                      ? ""
                      : "pointer",
                    width: "100%",
                    height: "80px",
                    backgroundColor:
                      !caseDetail?.is_existing_plan_uassist_possible
                        ? "#9E9E9E"
                        : "#215ECD",
                    borderRadius: "8px",
                    textAlign: "center",
                    padding: "8px",
                    lineHeight: "32px",
                  }}
                >
                  <Typography variant="h6" color="#fff">
                    {t("treat.uAssistPopup.continueTreatmentButton")}
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    color="#fff"
                    sx={{ fontWeight: 400 }}
                  >
                    {t("treat.uAssistPopup.usingExistingScan")}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  color={"rgba(0, 0, 0, 0.60)"}
                  marginTop={"16px"}
                >
                  <Trans
                    components={{
                      br: <br />,
                    }}
                  >
                    {t("treat.uAssistPopup.continueTreatmentDescription")}
                  </Trans>
                </Typography>
              </Box>
              <Box width={248}>
                <Box
                  onClick={() => {
                    // const asyncShowRefinementPage = async () => {
                    //   await dispatch(setOpenInitialFinal(false))
                    //   flushSync(() => setOpenGrid(false))
                    //   showRefinementPage()
                    // }
                    // asyncShowRefinementPage()
                    dispatch(openRefinement({ isSelfplan: false }))
                    setOpenUassist(false)
                  }}
                  sx={{
                    cursor: "pointer",
                    width: "100%",
                    height: "80px",
                    backgroundColor: "#215ECD",
                    borderRadius: "8px",
                    textAlign: "center",
                    padding: "8px",
                    lineHeight: "64px",
                  }}
                >
                  <Typography variant="h6" color="#fff">
                    {t("treat.uAssistPopup.submitRefinementButton")}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="#fff"
                    sx={{ fontWeight: 400 }}
                  >
                    {t("treat.uAssistPopup.uploadNewScan")}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  color={"rgba(0, 0, 0, 0.60)"}
                  marginTop={"16px"}
                >
                  <Trans
                    components={{
                      br: <br />,
                    }}
                  >
                    {t("treat.uAssistPopup.submitRefinementDescription")}
                  </Trans>
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <UButton
              onClickHandler={() => {
                setOpenUassist(false)
              }}
              variant={"text"}
              btnText={"CANCEL"}
            />
          </DialogActions>
        </Dialog>

        <Dialog open={showNoUassistPopup}>
          <DialogContent>{t("treat.nouAssistPopup.content")}</DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => {
                setShowNoUassistPopup(false)
              }}
            >
              ok
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={showNoUassistRetainerPopup}>
          <DialogContent>
            <Trans
              components={{
                newLine: <br />,
              }}
            >
              {"treat.nouAssistPopup.retainerContent"}
            </Trans>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => {
                setShowNoUassistRetainerPopup(false)
              }}
            >
              ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={isDeletePlan}>
          <DialogTitle>
            Choose a single treatment plan prior to submitting
          </DialogTitle>
          <DialogContent>
            Please delete one of the treatment plans by clicking the X next to
            the plan name before submitting.
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setisDeletePlan(false)
              }}
            >
              ok
            </Button>
          </DialogActions>
        </Dialog>
        {/* check ipr pop-up */}
        <Dialog open={checkIPRobj.show}>
          <DialogTitle
            sx={{ padding: "16px 24px", display: "flex", alignItems: "center" }}
          >
            <WarningAmberIcon sx={{ color: "#ED6C02", marginRight: "8px" }} />
            <Typography variant="inherit" color={"rgba(0, 0, 0, 0.87)"}>
              Collision Warning
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ paddingBottom: "12px" }}>
            <Typography variant="body1" color={"rgba(0, 0, 0, 1)"}>
              Mid-course collisions need to be resolved.
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontWeight: "bold" }}
              // marginTop={"16px"}
            >
              Failure to do so may impact treatment outcome.
            </Typography>
            <Box component={"div"} sx={{ display: "flex" }}>
              <Box sx={{ width: "100%" }}>
                <Typography
                  variant="body2"
                  color={"rgba(0, 0, 0, 0.60)"}
                  // marginTop={"16px"}
                  sx={{
                    display: checkIPRobj.showDetail ? "" : "none",
                    whiteSpace: "break-spaces",
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {checkIPRobj.detail}
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "space-between",
              padding: "8px 14px 8px 24px",
            }}
          >
            <Box>
              <UButton
                onClickHandler={() => {
                  setCheckIPRobj({
                    ...checkIPRobj,
                    showDetail: !checkIPRobj.showDetail,
                  })
                }}
                variant={"text"}
                btnText={
                  checkIPRobj.showDetail ? "Hide Details" : "Show Details"
                }
              />
            </Box>

            <Box>
              <UButton
                onClickHandler={() => {
                  setCheckIPRobj({ show: false, detail: "", showDetail: false })
                  callbackAfterIPRcheck && callbackAfterIPRcheck()
                }}
                variant={"outlined"}
                btnText={"Continue"}
                sxProp={{ marginRight: "8px" }}
              />
              <UButton
                onClickHandler={() => {
                  setCheckIPRobj({ show: false, detail: "", showDetail: false })
                  setisClickOrder(false)
                }}
                variant={"contained"}
                btnText={"Resolve"}
              />
            </Box>
          </DialogActions>
        </Dialog>
        {/* start refinement prompt */}
        <StartRefinementPrompt
          open={openStartRefinement}
          setOpen={setOpenStartRefinement}
        />

        {/* same label dialog */}
        <Dialog open={sameLabelDlg}>
          <DialogTitle id="alert-dialog-title">{"uDesign Cloud"}</DialogTitle>
          <DialogContent>
            {"There are duplicates, please relabel!"}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setSameLabelDlg(false)}
              autoFocus
              sx={{ textTransform: "samelabel" }}
              size="medium"
              color="primary"
              variant="contained"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    )
  },
)
